import React from "react";

// Bootstrap 5 nav-tabs look
// (https://getbootstrap.com/docs/5.0/components/navs-tabs/#tabs) — a row
// of tabs sitting on a shared bottom divider, with the active tab's own
// bottom border "merging" into the page background below it, rather than
// the pill-shaped, rounded-all-around buttons used everywhere before this.
// One shared component so every tab bar in the app (main admin tabs, root
// and competitions sub-tabs, the profile page's tabs) looks and behaves
// identically instead of each repeating its own near-identical styling.
//
// tabs: [{ id, label, color?, pushRight? }]
//   color: overrides the active tab's text color (used for the
//     competitions sub-tabs, which color each status tab to match its
//     status elsewhere in the admin panel) — defaults to the site's
//     accent blue.
//   pushRight: true on the first tab that should start a right-aligned
//     group (e.g. "Chart" among the competition sub-tabs) — every tab
//     after it in the array follows along automatically once one flex
//     item has margin-left: auto, so only that first one needs the flag.
export default function TabBar({ tabs, activeId, onSelect }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", borderBottom: "1px solid var(--border-color)", marginBottom: 20 }}>
      {tabs.map((t) => {
        const active = t.id === activeId;
        return (
          <button
            key={t.id}
            className={`nav-tab-button${active ? " nav-tab-button-active" : ""}`}
            onClick={() => onSelect(t.id)}
            style={{
              padding: "8px 16px",
              marginBottom: -1,
              marginLeft: t.pushRight ? "auto" : 0,
              border: "1px solid transparent",
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderColor: active ? "var(--border-color) var(--border-color) var(--bg-page)" : "transparent",
              background: active ? "var(--bg-page)" : "transparent",
              color: active ? t.color || "var(--accent-blue)" : "var(--text-secondary)",
              cursor: "pointer",
              fontWeight: active ? 600 : 400,
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
